export default __webpack_public_path__ + "static/media/cofeecup.983c558d.png";